import { render } from "./ApplicationPreschool.vue?vue&type=template&id=539f1374"
import script from "./ApplicationPreschool.vue?vue&type=script&lang=js"
export * from "./ApplicationPreschool.vue?vue&type=script&lang=js"

import "./ApplicationPreschool.vue?vue&type=style&index=0&id=539f1374&lang=css"

import exportComponent from "/home/time/IdeaProjects/mektep-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__